
import { computed, defineComponent } from 'vue';

export default defineComponent({
  props: {
    data: {
      type: String
    }
  },
  setup(props) {
    const textColor = computed(() => {
      switch (props.data) {
        case 'On Track':
          return 'text-green-500';
        case 'Behind':
          return 'text-yellow-500';
        case 'Ahead':
          return 'text-blue-500';
        default:
          return '';
      }
    });
    return {
      textColor
    };
  }
});
